var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"twitter"}},[(_vm.isLoading)?_c('Loading'):_vm._e(),_c('main',{attrs:{"role":"main"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }